defineDs('Shared/Framework/Ensighten/Scripts/DynamicPageTracking', [
  'Shared/Framework/Ensighten/Scripts/Tracking'
], function (Tracking) {
  window.navigation?.addEventListener('navigate', () => {
    console.debug('DynamicPageTracking: navigate event detected, tracking page view');
    Tracking.trackPageView({
      eventList: ['page_view'],
      pageType: 'ContentPage',
    });
  });
});